/**
 * Le rechargement automatique d'une page dont un morceau ne se charge pas (l'ecran de la diffusion, livre a part, dans
 * `routes.tsx`). Le plus souvent l'app a ete mise a jour depuis l'ouverture de l'onglet : les noms des fichiers ont
 * change, l'ancien n'existe plus, et recharger la page va chercher la nouvelle version.
 *
 * **Une seule fois par session de l'onglet**, pour ne jamais boucler : si la page rechargee n'a toujours pas son fichier
 * (le reseau est coupe, le serveur est tombe), recharger encore ne changerait rien et recommencerait sans fin. La trace du
 * premier rechargement est dans `sessionStorage`, que certains navigateurs refusent (navigation privee, stockage bloque,
 * plein) : sans pouvoir la lire et l'ecrire, on ne recharge pas, on laisse l'ecran dire l'echec et son bouton.
 */

/** La trace, dans la session de l'onglet, d'un rechargement deja fait. */
export const CLE_RECHARGEMENT = "castellan.rechargement-automatique";

const RECHARGER_LA_PAGE = (): void => window.location.reload();

/** Recharge la page si elle ne l'a pas deja fait dans cette session. Rend vrai quand il l'a rechargee. */
export function rechargerUneFois(recharger: () => void = RECHARGER_LA_PAGE): boolean {
  try {
    if (window.sessionStorage.getItem(CLE_RECHARGEMENT) !== null) return false;
    window.sessionStorage.setItem(CLE_RECHARGEMENT, "1");
  } catch {
    return false;
  }
  recharger();
  return true;
}
